module.exports = __webpack_public_path__ + "static/4-01abd07eeb5f033d32c3b19a08cef93b.jpg";